export default "__VITE_ASSET__3a45f720__"